var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeCropped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#848484",
    viewBox: "8 16 48 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    fillRule: "evenodd",
    d: "M32 18.667c-9.729 0-18.023 5.751-21.438 13.851a1.333 1.333 0 1 1-2.457-1.036C11.942 22.382 21.212 16 32 16s20.058 6.382 23.895 15.482a1.333 1.333 0 1 1-2.457 1.036c-3.415-8.1-11.71-13.851-21.438-13.851Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    fillRule: "evenodd",
    d: "M32 45.333c-9.729 0-18.023-5.751-21.438-13.851a1.333 1.333 0 1 0-2.457 1.036C11.942 41.618 21.212 48 32 48s20.058-6.382 23.895-15.482a1.333 1.333 0 1 0-2.457-1.036c-3.415 8.1-11.71 13.851-21.438 13.851Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    fillRule: "evenodd",
    d: "M32 25.334a6.667 6.667 0 1 0 0 13.333 6.667 6.667 0 0 0 0-13.333ZM22.667 32a9.333 9.333 0 1 1 18.666 0 9.333 9.333 0 0 1-18.666 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCropped);
export default __webpack_public_path__ + "static/media/eye-cropped.3553fa3f510affe30b2c55a00f5aad18.svg";
export { ForwardRef as ReactComponent };